import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppSettingsService} from '../../../services/app-settings.service';
import {Feature} from 'ol';

@Component({
  selector: 'app-navigation',
  template: `
    <div class="factor elem" *ngIf="showCondition && feature">
      <div class="wrap" (clickOutside)="OnClickOutSide($event)" [delayClickOutsideInit]="true">
        <div class="row">
          <div class="col col-12">
            <div class="head">
              <h2>اطلاعات موقعیت انتخاب شده</h2>
            </div>
          </div>
          <div class="col col-12">
            <div class="row" *ngFor="let item of feature.getProperties() | keyvalue">
              <div *ngIf="item.key !== 'geometry'">
                <h3>{{settings.translateEnglish(item.key)}}</h3>
                <span>{{settings.translateEnglish(item.value)}}</span>
              </div>
            </div>
          </div>
          <div class="col col-12">
            <div class="head">
              <div *ngIf="feature.getProperties().name !== 'current_location'">
                <h4>مسیر یابی</h4>
                <br>
                <a (click)="navigate('driving-car')" style="margin: 20px">
                  <i class="icon ico-car-outline"></i>
                </a>
                <a (click)="navigate('foot-walking')" style="margin: 20px">
                  <i class="icon ico-person-outline"></i>
                </a>
<!--                <a (click)="navigate('wheelchair')" style="margin: 20px">-->
<!--                  <i class="icon ico-person-outline"></i>-->
<!--                </a>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class NavigationComponent implements OnInit {
  @Input() showCondition = false;
  @Input() feature: Feature;
  @Output() ClickOutSide = new EventEmitter<Event>();
  @Output() getNavigation = new EventEmitter<any>();

  constructor(public settings: AppSettingsService) {
  }

  ngOnInit() {
  }

  OnClickOutSide(event: Event) {
    console.log(event);
    if (this.showCondition === true) {
      this.ClickOutSide.emit(event);
    }
  }

  navigate(mode: string) {
    this.getNavigation.emit({
      destination: this.feature,
      mode
    });
  }
}
